import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import $api from '../api'
import { Song } from './songsSlice'
import { GetListDTO } from '../dto'
import { LocaleType } from '../localization/i18n'

type PlaylistId = string
interface State {
  playlists: Record<PlaylistId, Playlist>
  total: number
}
export interface CreatePlaylistDTO {
  title: string
  description: {
    [key in LocaleType]?: string
  }
  image: string
  songs: Song['_id'][]
  moods?: string[]
  businesses?: string[]
  daytimes?: string[]
  styles?: string[]
  userOrder?: string
}

// export type CreatePlaylistDTO = EditPlaylistDTO
export type EditPlaylistDTO = CreatePlaylistDTO & {
  _id: Playlist['_id']
}

export enum PlaylistOrderBy {
  TITLE = 'title',
  VIEW_COUNT = 'viewCount',
}

export interface GetListPlaylistsDto extends GetListDTO {
  oderBy?: PlaylistOrderBy
  mood?: string
  business?: string
  daytime?: string
  style?: string
}

export interface PlaylistCategory {
  _id: string
  title: string
  image: string
}

export interface Playlist
  extends Omit<PlaylistBrief, 'songs' | 'moods' | 'businesses' | 'daytimes' | 'styles'> {
  moods?: PlaylistCategory[]
  businesses?: PlaylistCategory[]
  daytimes?: PlaylistCategory[]
  styles?: PlaylistCategory[]
  songs: Song[]
}

export interface PlaylistBrief {
  title: string
  description: {
    [key in LocaleType]?: string
  }
  image: string
  songs: string[]
  userOrder?: string
  _id: string
  totalDuration?: number
  songsCount?: number
  updatedAt?: string
  moods?: string[]
  businesses?: string[]
  daytimes?: string[]
  styles?: string[]
}

export const initialState: State = {
  playlists: {},
  total: 0,
}

export const attemptCreatePlaylist = createAsyncThunk<Playlist, CreatePlaylistDTO>(
  'playlists/playlist-create',
  async (payload) => {
    try {
      const response = await $api.post(`playlists/create`, payload)
      return response.data
    } catch (e) {
      console.log('eeee', e)
    }
  },
)

export const attemptGetPlaylistsList = createAsyncThunk<
  { playlists: Playlist[]; total: number },
  GetListPlaylistsDto
>('playlists/list', async (payload) => {
  const response = await $api.post('playlists/admin/list', payload)
  return response.data
})

export const attemptGetPlaylist = createAsyncThunk<Playlist, string>(
  'playlists/get-playlist',
  async (id) => {
    const response = await $api.post(`playlists/get/${id}`)
    console.log('attemptGetPlaylist response.data:', response.data)

    return response.data
  },
)

export const attemptEditPlaylist = createAsyncThunk<void, EditPlaylistDTO>(
  'playlists/playlist-edit',
  async (payload) => {
    const response = await $api.post(`playlists/update/${payload._id}`, payload)
    console.log('attemptEditPlaylist response.data:', response.data)
    // return response.data
    return
  },
)

export const attemptDeletePlaylist = createAsyncThunk<Playlist['_id'], Playlist['_id']>(
  'playlists/playlist-delete',
  async (playlistId) => {
    await $api.post(`playlists/delete/${playlistId}`)
    return playlistId
  },
)

export const playlistsReducer = createSlice({
  name: 'playlists',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(attemptCreatePlaylist.fulfilled, (state, { payload }) => {
      // state.playlists[payload._id] = payload //don't need it as we are always fetching playlists when coming to the
    })
    builder.addCase(attemptGetPlaylistsList.fulfilled, (state, { payload }) => {
      state.playlists = {}
      payload.playlists.forEach((playlist) => {
        state.playlists[playlist._id] = playlist
      })
      state.total = payload.total
    })
    builder.addCase(attemptDeletePlaylist.fulfilled, (state, { payload: _id }) => {
      delete state.playlists[_id]
    })
  },
})

export const {} = playlistsReducer.actions
export default playlistsReducer.reducer
